module.exports = __webpack_public_path__ + "static/media/03_FVCON The_Connection.ab805036.png";